"use client";

import React, { MouseEvent } from "react";

interface OneTrustLinkProps {
  children?: React.ReactNode;
}

export const OneTrustLink: React.FC<OneTrustLinkProps> = ({ children }) => {
  const handleOnClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    if (typeof window.OneTrust === "undefined") {
      console.error("Error: OneTrust is not defined");
      return;
    }

    window.OneTrust.ToggleInfoDisplay();
  };

  return (
    <a href="" target="_self" onClick={handleOnClick}>
      {children || "Your Privacy Choices"}
    </a>
  );
};
